import { create } from 'zustand';

export enum ImagePullPolicy {
  IF_NOT_PRESENT = 'IfNotPresent',
  ALWAYS = 'Always',
  NEVER = 'Never',
}

interface ImageOptionsState {
  imagePullPolicy: ImagePullPolicy;
}

const initState: ImageOptionsState = {
  imagePullPolicy: ImagePullPolicy.IF_NOT_PRESENT,
};

interface ImageOptionsActions {
  updateImagePullPolicy: (policy: ImagePullPolicy) => void;
  reset: () => void;
}

export const useImageOptionsStore = create<ImageOptionsState & ImageOptionsActions>()((set) => ({
  ...initState,
  updateImagePullPolicy: (policy) => set(() => ({ imagePullPolicy: policy })),
  reset: () => set(initState),
}));
